module.exports = __webpack_public_path__ + "static/img/scream.3259cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/scream.png
// module id = VgYp
// module chunks = 0